import { render, staticRenderFns } from "./AdoptionNavbar.vue?vue&type=template&id=488d1ef0&scoped=true&"
import script from "./AdoptionNavbar.vue?vue&type=script&lang=js&"
export * from "./AdoptionNavbar.vue?vue&type=script&lang=js&"
import style0 from "./AdoptionNavbar.vue?vue&type=style&index=0&id=488d1ef0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488d1ef0",
  null
  
)

export default component.exports